export default __webpack_public_path__ + "static/FFF1-f4b23192be998fc98c5eede7ae5ab576.png";